export function normalizeSchemeOpportunityItem(row) {
  if (!row) return null

  const status = row.status || ''
  const stage =
    status === 'Completed' ? '已对接' : '急需方案'

  const industry = row.categoryLabel || ''
  const typeLabel = row.typeLabel || row.type || ''

  const tags = [industry, typeLabel].filter(Boolean).slice(0, 3)

  return {
    id: row.id || '',
    entityId: row.entityId || row.id || '',
    title: row.title || row.explainRemark || '',
    type: row.type || '',
    typeLabel: row.typeLabel || '',
    industry: industry,
    description: row.description || '',
    explainRemark: row.explainRemark || '',
    remark: row.remark || '',
    status: status,
    statusLabel: row.statusLabel || '',
    mobilePhone: row.mobilePhone || '',
    contactName: row.creationName || '',
    creationDate: row.creationDate || '',
    // 面向前端卡片模型补齐字段（依赖后端公共 SQL 的返回列）
    company: row.creationName || '待补充',
    region: '待补充',
    area: '待补充',
    // 状态映射到页面的 badge 颜色规则
    stage: stage,
    mode: typeLabel || row.type || '平台定向推送',
    score: status === 'Completed' ? 92 : 86,
    matched: industry || '待补充',
    summary: row.explainRemark || row.description || row.remark || '',
    next: row.remark || '建议进入详情查看后再发起跟进',
    deadline: '待补充',
    // Home/Opportunity 页面需要的展示字段
    badgeText: stage === '已对接' ? '可协作推进' : '可直接对接',
    badgeTone: stage === '已对接' ? 'blue' : 'red',
    tags: tags.length ? tags : ['待补充'],
    desc: row.explainRemark || row.description || row.remark || '',
    raw: row
  }
}
